import inertTraverse from "./inertTraverse";

const defaultCallback = () => true;
window.NB_FOCUS_LOG = +(window.localStorage.getItem('NB_FOCUS_LOG') || 0);
export default function focusElement(currentElement, direction, callback = defaultCallback) {
  const elements = [...document.querySelectorAll('[tabIndex]')];
  const tabElements = elements.filter(element => inertTraverse(element));
  const currentIndex = tabElements.findIndex(tabElement => tabElement === currentElement);
  const nextIndex = (tabElements.length + currentIndex + direction) % tabElements.length;
  const nextElement = tabElements[nextIndex];
  const passed = callback && callback(nextElement);
  if (!passed) return;
  nextElement?.focus();
  requestAnimationFrame(() => {
    nextElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
  });
  if (window.NB_FOCUS_LOG) console.log('focus changed', tabElements[currentIndex], '=>', nextElement);
}